import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c78d92a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics__title" }, "аналитика алкогольного рынка", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics__subtitle" }, "Участники алкогольного рынка", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics__description" }, " Организации (ИП) зафиксировавшие в ЕГАИС производство и (или) оборот ЭС, АП и ССП ", -1))
const _hoisted_5 = { class: "statistics__header" }
const _hoisted_6 = { class: "statistics__list" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "statistic__value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics__note" }, " Примечание: Показатели суммированию не подлежат, поскольку отдельное юридическое лицо может осуществлять несколько видов деятельности одновременно. ", -1))

import { DataRange } from '@/entities/DataRange'
import { getLocaleString } from '@/shared/helpers'
import { StatisticsPart } from '../model/types/statistics'
import { useReportStore } from '@/pages/Report'
import icons from '@/shared/assets/icons/icons'
import { computed } from 'vue'
import NotFoundBlock from '@/shared/ui/NotFoundBlock/NotFoundBlock.vue'
import { ProductType } from '@/entities/ProductTypes'
import { ActivityName } from '@/shared/consts/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistics',
  props: {
    isVertical: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	isVertical: boolean
};



const reportStore = useReportStore()
const statisticsFromServer = computed(() => reportStore.state.commonInfo)
const mappedStatistics = computed<StatisticsPart[]>(() => {
	if (statisticsFromServer.value) {
		return [
			{
				title: 'Количество производителей',
				list: [
					{
						id: ProductType.DISTILLATES,
						image: require('@/shared/assets/icons/barrels.svg'),
						title: 'Этилового спирта',
						value: statisticsFromServer.value.producersSD
					},
					{
						id: ProductType.WITH_ALCOHOL,
						image: icons.withAlcohol,
						title: 'Спиртосодержащей <br/> продукции',
						value: statisticsFromServer.value.producersSS
					},
					{
						id: ProductType.ALCOHOL,
						image: icons.vodka,
						title: 'Алкогольной <br/> продукции',
						value: statisticsFromServer.value.producersAP
					},
					{
						id: ProductType.BEER,
						image: require('@/shared/assets/icons/beer.svg'),
						title: 'Напитков <br/> брожения',
						value: statisticsFromServer.value.producersBeer
					}
				]
			},
			{
				title: 'Количество перевозчиков ЭС и ССП 25%',
				list: [
					{
						id: 'carriers',
						image: icons.truck,
						title: 'Перевозчиков',
						value: statisticsFromServer.value.transporters
					}
				]
			},
			{
				title: 'Количество участников внешнеэкономической деятельности',
				list: [
					{
						id: ActivityName.IMPORT,
						image: icons.import,
						title: 'Импортеров',
						value: statisticsFromServer.value.importers
					},
					{
						id: ActivityName.EXPORT,
						image: icons.export,
						title: 'Экспортеров',
						value: statisticsFromServer.value.exporters
					}
				]
			},
			{
				title: 'Количество розничных магазинов и общепита',
				list: [
					{
						id: 'stores',
						image: icons.retailPoint,
						title: 'Магазинов',
						value: statisticsFromServer.value.retailersStores
					},
					{
						id: 'restaurant',
						image: icons.restaurant,
						title: 'Организаций общественного питания',
						value: statisticsFromServer.value.retailersRestaurants
					}
				]
			}
		]
	} else {
		return []
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_unref(DataRange), { style: {"margin-bottom":"1rem"} }),
    _createElementVNode("div", {
      class: _normalizeClass({'vertical': props.isVertical})
    }, [
      (_unref(reportStore).getCommonInfo)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(mappedStatistics), (part) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "statistics__part",
              key: part.title
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(part.title), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "statistic",
                    key: item.id
                  }, [
                    (item.image.indexOf('<svg') !== -1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: item.image,
                          class: "statistic__img"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "statistic__img",
                          src: item.image,
                          alt: item.title
                        }, null, 8, _hoisted_8)),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: "statistic__name",
                        innerHTML: item.title
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getLocaleString)(item.value)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        : (_unref(reportStore).state.error)
          ? (_openBlock(), _createBlock(NotFoundBlock, {
              key: 1,
              text: "Данные не найдены"
            }))
          : _createCommentVNode("", true)
    ], 2),
    _hoisted_11
  ]))
}
}

})